import './App.css';
import React from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';

import AttendanceNavbar from './components/AttendanceNavbar';
import ProtectedRoute from './components/ProtectedRoute';
import { ROLES, MANAGEMENT, OVERSIGHT } from './components/attendance/roles';

import Home from './components/Home';
import RegisterPage from './components/RegisterPage';
import AttendanceDashboard from './components/AttendanceDashboard';
import MonthlyReport from './components/MonthlyReport';
import LeaveManagement from './components/LeaveManagement';
import NotificationsPage from './components/NotificationsPage';
import MyProfile from './components/MyProfile';
import ManagerDashboard from './components/ManagerDashboard';
import ReportsAnalytics from './components/ReportsAnalytics';
import EmployeeManagement from './components/EmployeeManagement';
import AttendanceEntry from './components/AttendanceEntry';
import RuralSubmissions from './components/RuralSubmissions';
import WeeklySubmission from './components/WeeklySubmission';
import BiometricIntegration from './components/BiometricIntegration';
import AuditTrail from './components/AuditTrail';
import SystemSettings from './components/SystemSettings';

/** Every signed-in screen shares the navbar, so wrap them once. */
const Screen = ({ roles, children }) => (
  <ProtectedRoute roles={roles}>
    <AttendanceNavbar />
    {children}
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Home />} />
          <Route path="/register" element={<RegisterPage />} />

          {/* Every signed-in staff member */}
          <Route path="/dashboard" element={<Screen><AttendanceDashboard /></Screen>} />
          <Route path="/monthly-report" element={<Screen><MonthlyReport /></Screen>} />
          <Route path="/leave-management" element={<Screen><LeaveManagement /></Screen>} />
          <Route path="/notifications" element={<Screen><NotificationsPage /></Screen>} />
          <Route path="/my-profile" element={<Screen><MyProfile /></Screen>} />

          {/* Supervisors, department heads and management */}
          <Route path="/manager-dashboard" element={<Screen roles={OVERSIGHT}><ManagerDashboard /></Screen>} />
          <Route path="/reports" element={<Screen roles={OVERSIGHT}><ReportsAnalytics /></Screen>} />
          <Route path="/employee-management" element={<Screen roles={OVERSIGHT}><EmployeeManagement /></Screen>} />
          <Route path="/attendance-entry" element={<Screen roles={OVERSIGHT}><AttendanceEntry /></Screen>} />
          <Route path="/rural-submissions" element={<Screen roles={OVERSIGHT}><RuralSubmissions /></Screen>} />
          <Route path="/weekly-submission" element={<Screen roles={OVERSIGHT}><WeeklySubmission /></Screen>} />

          {/* HR, principal and system administrator */}
          <Route path="/biometric-integration" element={<Screen roles={MANAGEMENT}><BiometricIntegration /></Screen>} />
          <Route path="/audit-trail" element={<Screen roles={MANAGEMENT}><AuditTrail /></Screen>} />
          <Route path="/system-settings" element={<Screen roles={[ROLES.ADMIN]}><SystemSettings /></Screen>} />

          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
